import type { CanvasJSONLikeObject } from '@doer/frontend-components/creativity-editor';
import { TEXT_DEFAULTS, type FontWeight } from './text-defaults';

export interface DiscountValueOpts {
  pieceId: string;
  text: string;
  fontSize: number;
  fontWeight?: FontWeight;
  textAlign?: 'left' | 'center' | 'right';
  position: { left: number; top: number; width: number; height: number };
  fill?: string;
}

export function buildDiscountValue(opts: DiscountValueOpts): CanvasJSONLikeObject {
  const { pieceId, text, fontSize, position, fontWeight = 'bold', fill = '#0030eb', textAlign = 'center' } = opts;
  return {
    ...TEXT_DEFAULTS,
    type: 'Textbox',
    pieceId,
    text,
    fontSize,
    fontWeight,
    lineHeight: 1.0,
    charSpacing: -50,
    textAlign,
    originY: 'center',
    left: position.left,
    top: position.top,
    width: position.width,
    height: position.height,
    fill,
    objectCaching: true
  };
}
